import {
  countSlotsInPlage,
  formatPlageLabel,
  resolvePasReservationMinutes,
  summarizeCommercantHoraires,
} from './prestationDisponibilite.js';

export const MODE_CAPACITE_LABELS = {
  INDIVIDUEL: 'Individuel (1 place par créneau)',
  COLLECTIF: 'Collectif (plusieurs participants par créneau)',
  EXCLUSIF: 'Exclusif (ressource / terrain)',
};

export function resolveModeCapaciteLabel(commercant, prestation) {
  const maxParticipants = Math.max(1, Number(prestation?.maxParticipants) || 1);
  const type = String(prestation?.typePrestation || '').toUpperCase();
  const moduleCreneaux = Boolean(commercant?.moduleCreneaux || commercant?.priseCreneaux);

  if (maxParticipants <= 1) return MODE_CAPACITE_LABELS.INDIVIDUEL;
  if (type === 'CRENEAUX' && moduleCreneaux) return MODE_CAPACITE_LABELS.EXCLUSIF;
  if (type === 'RENDEZ_VOUS') return MODE_CAPACITE_LABELS.COLLECTIF;
  return MODE_CAPACITE_LABELS.INDIVIDUEL;
}

function estimateSlotsFromBoutiqueHoraires(horaires, pasMinutes, dureeMinutes) {
  let total = 0;
  (Array.isArray(horaires) ? horaires : [])
    .filter((h) => h?.actif !== false && h?.heureDebut && h?.heureFin)
    .forEach((h) => {
      total += countSlotsInPlage(h.heureDebut, h.heureFin, pasMinutes, dureeMinutes);
    });
  return total;
}

function estimateSlotsFromCustomPlages(creneaux, pasMinutes, dureeMinutes) {
  let total = 0;
  (Array.isArray(creneaux) ? creneaux : [])
    .filter((c) => c?.actif !== false && c?.heureDebut && c?.heureFin)
    .forEach((c) => {
      total += countSlotsInPlage(c.heureDebut, c.heureFin, pasMinutes, dureeMinutes);
    });
  return total;
}

/**
 * Résumé lecture seule pour le modal « Visualiser » (admin).
 */
export function buildPrestationPreviewSummary({ commercant, prestation, creneaux = [] }) {
  const pasMinutes = resolvePasReservationMinutes(commercant, prestation);
  const dureeMinutes = parseInt(prestation?.dureeMinutes, 10) || 60;
  const customPlages = (Array.isArray(creneaux) ? creneaux : []).filter((c) => c?.actif !== false);
  const usesCustomPlages = customPlages.length > 0;

  let disponibiliteMode = 'Horaires boutique (automatique)';
  let plagesLines = [];

  if (usesCustomPlages) {
    disponibiliteMode = 'Plages personnalisées pour cette activité';
    plagesLines = customPlages.map(formatPlageLabel);
  } else {
    const resume = summarizeCommercantHoraires(commercant?.horaires);
    plagesLines = resume.map((row) => `${row.label} : ${row.plages.join(' · ')}`);
    if (plagesLines.length === 0) {
      plagesLines = ['Aucun horaire boutique configuré'];
    }
  }

  const slotsEstimate = usesCustomPlages
    ? estimateSlotsFromCustomPlages(customPlages, pasMinutes, dureeMinutes)
    : estimateSlotsFromBoutiqueHoraires(commercant?.horaires, pasMinutes, dureeMinutes);

  const prix = Number(prestation?.prix);
  const prixPromo = prestation?.prixPromo != null ? Number(prestation.prixPromo) : null;

  return {
    nom: prestation?.nom || '—',
    description: prestation?.description || '',
    typePrestation: prestation?.typePrestation,
    dureeMinutes,
    prix: Number.isFinite(prix) ? prix : null,
    prixPromo: Number.isFinite(prixPromo) ? prixPromo : null,
    maxParticipants: Math.max(1, Number(prestation?.maxParticipants) || 1),
    actif: prestation?.actif !== false,
    modeCapaciteLabel: resolveModeCapaciteLabel(commercant, prestation),
    disponibiliteMode,
    plagesLines,
    pasMinutes,
    slotsEstimate,
    usesCustomPlages,
  };
}
